import React from 'react';
import { TableRow, TableCell, IconButton, Box, Tooltip } from '@mui/material';
import { Check, Close, Edit, Delete } from '@mui/icons-material';

import { ILegalTransactionMeetingEmail } from '../../../Interfaces/ILegalTransactionMeetingEmail';

interface Props {
  idLegalTransactionMeeting: number;
  meetingEmailObject: ILegalTransactionMeetingEmail;
  meetingEmailArray: ILegalTransactionMeetingEmail[];
  setMeetingEmailArray: (arr: ILegalTransactionMeetingEmail[]) => void;
  onEdit: () => void;
}

const BoolCell = ({ value }: { value: boolean }) =>
  value ? (
    <Check fontSize='small' sx={{ color: 'success.main' }} />
  ) : (
    <Close fontSize='small' sx={{ color: 'text.disabled' }} />
  );

export const LegalTransactionMeetingEmailRow: React.FC<Props> = ({
  meetingEmailObject,
  meetingEmailArray,
  setMeetingEmailArray,
  onEdit,
}) => {
  const handleDelete = () => {
    setMeetingEmailArray(
      meetingEmailArray.filter(
        e =>
          e.idLegalTransactionMeetingEmail !==
          meetingEmailObject.idLegalTransactionMeetingEmail
      )
    );
  };

  return (
    <TableRow>
      <TableCell>{meetingEmailObject.Title}</TableCell>
      <TableCell>
        <BoolCell value={!!meetingEmailObject.sendOnCreation} />
      </TableCell>
      <TableCell>
        <BoolCell value={!!meetingEmailObject.sendOnReschedule} />
      </TableCell>
      <TableCell>
        <BoolCell value={!!meetingEmailObject.sendOnCancelling} />
      </TableCell>
      <TableCell>{meetingEmailObject.DaysBeforeDate}</TableCell>
      <TableCell>
        <BoolCell value={!!meetingEmailObject.sendWithCalenderFile} />
      </TableCell>
      <TableCell>
        <Box display='flex' gap={0.5}>
          <Tooltip title='Bearbeiten'>
            <IconButton size='small' onClick={onEdit}>
              <Edit fontSize='small' />
            </IconButton>
          </Tooltip>
          <Tooltip title='Löschen'>
            <IconButton size='small' color='error' onClick={handleDelete}>
              <Delete fontSize='small' />
            </IconButton>
          </Tooltip>
        </Box>
      </TableCell>
    </TableRow>
  );
};
